import { render, staticRenderFns } from "./DoctorSchedule.vue?vue&type=template&id=531bc20e&scoped=true"
import script from "./DoctorSchedule.vue?vue&type=script&lang=js"
export * from "./DoctorSchedule.vue?vue&type=script&lang=js"
import style0 from "./DoctorSchedule.vue?vue&type=style&index=0&id=531bc20e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531bc20e",
  null
  
)

export default component.exports